import { RouterProvider } from "react-router-dom";
import { routes } from "./router/route";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./redux/Store";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { loginUser, setUserData } from "./redux/reducers/profileReducer";
import {
  fetchUserInfo,
  updateLoginUserData,
  user,
} from "./redux/reducers/UserReducer";
import { toast } from "react-toastify";

function App() {
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

  const dispatch = useDispatch<AppDispatch>();
  const token = localStorage.getItem("token");
  const userData = useSelector(user);

  const loginUserStatus = useSelector(
    (state: RootState) => state.profileReducer.statusCode
  );

  const loginUserData = useSelector(
    (state: RootState) => state.profileReducer.userData
  );

  const isAuthenticated = useIsAuthenticated();

  const { instance } = useMsal();

  const account = instance.getActiveAccount();

  useEffect(() => {
    if (isAuthenticated && !token) {
      dispatch(loginUser({ email: account?.username }));
    }
  }, [isAuthenticated, account?.username]);

  useEffect(() => {
    if (loginUserStatus === 200) dispatch(updateLoginUserData(loginUserData));
  }, [loginUserStatus]);

  useEffect(() => {
    // if(token)
    if (token && userData?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userroles");
      toast.dismiss();
      toast.error(userData.message);
      return;
    }
    if (token && userData?.status !== 401 && userData?.status !== 200) {
      axios.defaults.headers["Authorization"] = token;
      dispatch(fetchUserInfo());
    }
  }, [userData, token]);

  return (
    <div>
      <RouterProvider router={routes} />
    </div>
  );
}

export default App;
